/* Alromob — Megameniu ilustrat. Linkurile există deja în HTML; scriptul doar deschide și închide panourile. */
(function(){
  var MQ = window.matchMedia('(max-width:899px)');
  function isMobile(){ return MQ.matches; }

  document.querySelectorAll('.alr-mm').forEach(function(root){
    if (root.dataset.alrInit) return;
    root.dataset.alrInit = '1';

    var toggle = root.querySelector('.alr-mm__toggle');
    var back   = root.querySelector('.alr-mm__back');
    var closeB = root.querySelector('.alr-mm__dclose');
    var title  = root.querySelector('.alr-mm__dtitle');
    var tabs   = Array.prototype.slice.call(root.querySelectorAll('.alr-mm__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.alr-mm__panel'));
    var baseTitle = title ? title.textContent : 'Meniu';
    var openIdx = null, tOpen = null, tClose = null;

    function setPanel(i){
      panels.forEach(function(p){ p.classList.remove('is-open'); });
      tabs.forEach(function(t){ t.setAttribute('aria-expanded','false'); });
      openIdx = i;
      if (i === null){
        root.classList.remove('is-at-2');
        if (back) back.hidden = true;
        if (title) title.textContent = baseTitle;
        return;
      }
      panels[i].classList.add('is-open');
      tabs[i].setAttribute('aria-expanded','true');
      if (isMobile()){
        root.classList.add('is-at-2');
        if (back){ back.hidden = false; back.focus({preventScroll:true}); }
        if (title) title.textContent = tabs[i].querySelector('.alr-mm__tl').textContent;
        panels[i].scrollTop = 0;
      }
    }
    function show(i){ clearTimeout(tClose); clearTimeout(tOpen); if (openIdx !== i) setPanel(i); }
    function showSoon(i){
      clearTimeout(tClose); clearTimeout(tOpen);
      if (openIdx !== null) { show(i); return; }          // deja deschis: comută imediat
      tOpen = setTimeout(function(){ show(i); }, 110);     // altfel, o mică întârziere la trecerea mouse-ului
    }
    function hideSoon(){ clearTimeout(tOpen); clearTimeout(tClose); tClose = setTimeout(function(){ setPanel(null); }, 200); }

    function openDrawer(){
      root.classList.add('is-menu-open');
      document.documentElement.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded','true');
      setPanel(null);
      if (tabs[0]) tabs[0].focus({preventScroll:true});
    }
    function closeDrawer(){
      root.classList.remove('is-menu-open');
      document.documentElement.style.overflow = '';
      toggle.setAttribute('aria-expanded','false');
      setPanel(null);
      toggle.focus();
    }

    if (toggle) toggle.addEventListener('click', function(){
      root.classList.contains('is-menu-open') ? closeDrawer() : openDrawer();
    });
    if (closeB) closeB.addEventListener('click', closeDrawer);
    if (back) back.addEventListener('click', function(){
      var i = openIdx; setPanel(null); if (tabs[i]) tabs[i].focus({preventScroll:true});
    });

    tabs.forEach(function(tab, i){
      tab.addEventListener('click', function(){ show(openIdx === i && !isMobile() ? null : i); });
      tab.addEventListener('mouseenter', function(){ if (!isMobile()) showSoon(i); });
      tab.addEventListener('mouseleave', function(){ if (!isMobile()) hideSoon(); });
      tab.addEventListener('keydown', function(e){
        if (isMobile()) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft'){
          e.preventDefault();
          var j = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          tabs[j].focus(); if (openIdx !== null) show(j);
        } else if (e.key === 'ArrowDown'){
          e.preventDefault(); show(i);
          var a = panels[i].querySelector('a'); if (a) a.focus();
        }
      });
    });
    panels.forEach(function(p, i){
      p.addEventListener('mouseenter', function(){ if (!isMobile()) show(i); });
      p.addEventListener('mouseleave', function(){ if (!isMobile()) hideSoon(); });
      p.addEventListener('focusout', function(e){
        if (!isMobile() && !root.contains(e.relatedTarget)) setPanel(null);
      });
    });

    document.addEventListener('keydown', function(e){
      if (e.key !== 'Escape') return;
      if (root.classList.contains('is-menu-open')){
        if (openIdx !== null){ var i = openIdx; setPanel(null); if (tabs[i]) tabs[i].focus(); }
        else closeDrawer();
      } else if (openIdx !== null){
        var t = tabs[openIdx]; setPanel(null); if (t) t.focus();
      }
    });
    document.addEventListener('click', function(e){
      if (!isMobile() && openIdx !== null && !root.contains(e.target)) setPanel(null);
    });

    MQ.addEventListener('change', function(){
      root.classList.remove('is-menu-open');
      document.documentElement.style.overflow = '';
      if (toggle) toggle.setAttribute('aria-expanded','false');
      setPanel(null);
    });
  });
})();
